import SuiviInterventionService from '@/modules/SuiviInterventions/services/SuiviInterventionService';

class DownloadPdf {
    public getInterventionPdf(id: number, fileName: string) : void {
        SuiviInterventionService.getRapportPDF(id).then(res => {
            const file = new Blob([res.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.target = 'blank';
            link.download = fileName + id;
            link.click();
            URL.revokeObjectURL(link.href);
        });
    }
}
export default new DownloadPdf();
